export {default as ErrorAlert} from './ErrorAlert';



// WEBPACK FOOTER //
// ./src/components/ErrorAlert/index.ts